import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { Slide, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./toast-theme.css";

import PrivateRoute from "./PrivateRoute";

import Login from "./pages/Login/Login";
import CreateOrganization from "./pages/Login/CreateOrganization";
import CreateAdmin from "./pages/Login/CreateAdmin";
import ResetPassword from "./pages/Login/ResetPassword";

import FleetTable from "./pages/fleettable/FleetTable";
import FleetManager from "./pages/fleetmanager/FleetManager";
import HelpPage from "./pages/help/Help";

import History from "./pages/history/History";
import CControlHistory from "./pages/history/CControlHistory";
import DControlHistory from "./pages/history/DControlHistory";

import FleetDashboard from "./pages/fleetmap/FleetDashboard";

import Profile from "./pages/profile/MyProfile";
import UpdateProfile from "./pages/profile/UpdateProfile";
import ChangePassword from "./pages/profile/ChangePassword";

import BillingSuccess from "./pages/billing/BillingSuccess";
import BillingCancel from "./pages/billing/BillingCancel";

import RouteDashboard from "./pages/fleetroute/RouteDashboard";

function App() {
  return (
    <div className="App">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false} // Must be false to see our custom progress bar
        newestOnTop={true}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Slide} // Fixed: Slide ensures proper exit logic
        toastClassName="tt-toast"
        bodyClassName="tt-body"
        progressClassName="tt-progress"
        limit={3}
      />

      <Router>
        <Routes>
          <Route exact path="/login" element={<Login />} />
          <Route path="/createOrganization" element={<CreateOrganization />} />
          <Route path="/createAdmin" element={<CreateAdmin />} />
          <Route path="/reset" element={<ResetPassword />} />
          <Route element={<PrivateRoute />}>
            <Route exact path="/fleettable" element={<FleetTable />} />
            
            <Route exact path="/history" element={<History />} />
            <Route path="/ccontrol-history" element={<CControlHistory />} />
            <Route path="/dcontrol-history" element={<DControlHistory />} />

            <Route path="/my-profile" element={<Profile />} />
            <Route path="/profile/update/" element={<UpdateProfile />} />
            <Route path="/password/update" element={<ChangePassword />} />
            
            <Route path="/fleetmanager" element={<FleetManager />} />
            <Route path="/help" element={<HelpPage />} />

            <Route path="/" element={<FleetDashboard />} />

            <Route path="/billing-success" element={<BillingSuccess />} />
            <Route path="/billing-cancel" element={<BillingCancel />} />

            <Route path="/route-manager" element={<RouteDashboard />} />
          </Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
